import gql from "graphql-tag";

export const INVENTORY_AND_SUPPLIERS_QUERY = gql`
  query {
    inventoryItems {
      id
      name
      unit
      materialType
    }
    suppliers {
      id
      name
    }
  }
`;

export const LOCATIONS_QUERY = gql`
  query StockEntryFields($inventoryItemId: Int){
    availableInventoryLocations(inventoryItemId: $inventoryItemId) {
      id
      name
    }
  }
`;

export const INVENTORY_LOCATIONS_QUERY = gql`
  query {
    inventoryLocations {
      id
      name
    }
  }
`;

export const ITEMS_AND_LOCATIONS_QUERY = gql`
  query {
    inventoryItems {
      id
      name
      inventoryLocations {
        id
        name
        inventoryQuantity
      }
    }
  }
`;
